import axios from "axios";

// Axios instance with credentials for all admin API calls
const adminApi = axios.create({ withCredentials: true });

export default adminApi;
